import type { DBInvoice, DBProject } from "@/lib/db-types";
import { UserLookup } from "@/hooks/use-users";
import { InnstillingerTab } from "./InnstillingerTab";
import { SrIcon } from "@/components/ui/SrIcon";
import { CollapsibleCard } from "@/components/shared/CollapsibleCard";
import { useProjectPermissions } from "@/hooks/use-project-permission";

interface AdministrasjonTabProps {
  project: DBProject;
  customer: any;
  allUsers: UserLookup[];
  invoices: DBInvoice[];
}

export function AdministrasjonTab({
  project,
  customer,
  allUsers,
  invoices,
}: AdministrasjonTabProps) {
  // VIB-722c: batch permission-lookup for alle gates på Detaljer-tabben.
  const permissions = useProjectPermissions(project.id);

  return (
    <div className="space-y-4">
      <CollapsibleCard
        title="Detaljer"
        icon={<SrIcon name="settings2" className="w-5 h-5 text-primary" />}
        defaultOpen
      >
        <InnstillingerTab
          project={project}
          customer={customer}
          allUsers={allUsers}
          invoices={invoices}
          canEditInvoiceTerms={permissions.edit_invoice_terms}
          canEditContractAmount={permissions.edit_contract_amount}
        />
      </CollapsibleCard>

      {/* VIB-947: Provisjonssplitt-kortet er fjernet herfra — provisjonsbeløp skal
          ikke vises på prosjektkortet/Detaljer. Flyttes til en egen, tilgangsstyrt
          provisjonsrapporterings-funksjon. ProvisjonTab.tsx beholdes som
          utgangspunkt for den. */}
    </div>
  );
}
